<lib-table [tableColumns]="salesLeadsColumns" [api]="api" [title]="title"
 [searchUIOptions]="searchUIOptions" [helpLinkURL]="supportVideoUrl" [resourceMessages]="resourceMessages"
 (smHandleAddButtonClick)="handleAddButtonClick($event)" (smHandleUpdateButtonClick)="handleUpdateButtonClick($event)"></lib-table>
